export const zhCnLocale = {
  model: {
    store: '店铺'
  },
  store: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    email: '邮箱',
    name: '名称',
    phone: '手机号码',
    latitude: '纬度',
    longitude: '经度',
    countryId: 'Country',
    kind: '类型',
      kinds: {
        flagship_store: '旗舰店',
        store_in_store: '店中店',
        dealer: '经销商',
      },
    status: '状态',
      statuses: {
        auto: '自动',
        business: '营业中',
        rest: '休息中',
      },
    miniProgramPath: '小程序相对路劲',
    wxacode: '小程序码',
    country: '国家',
    images: '图片',
    businessHoursAttributes: 'Business hours attributes',
  }
}

export const enLocale = {
  model: {
    store: 'Store'
  },
  store: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    address: 'Address',
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
    latitude: 'Latitude',
    longitude: 'Longitude',
    countryId: 'Country',
    kind: 'Kind',
      kinds: {
        flagship_store: 'Flagship store',
        store_in_store: 'Store in store',
        dealer: 'Dealer',
      },
    status: 'Status',
      statuses: {
        auto: 'Auto',
        business: 'Business',
        rest: 'Rest',
      },
    miniProgramPath: 'Mini program path',
    wxacode: 'Wxacode',
    country: 'Country',
    images: 'Images',
    businessHoursAttributes: 'Business hours attributes',
  }
}

